import('core-js/stable');
import('whatwg-fetch');
import('unorm');
